import { createSelector } from "@reduxjs/toolkit";
import { SET_CURRENT_ITEM, SET_PLAYBACK_STATE } from "../actions/playbackStateActions";

export const getCurrentPlaybackState = createSelector(
    state => state.playbackState, 
    playbackState => playbackState.playbackInfo
);

export const anyPlaybackState = createSelector(
    state => state.playbackState,
    playbackState => playbackState.playbackInfo !== undefined
);

export const isPlaying = createSelector(
    state => state.playbackState.playbackInfo, 
    playbackInfo => playbackInfo && playbackInfo.is_playing
);

export const getCurrentItem = createSelector(
    state => state.playbackState,
    playbackState => playbackState.currentItem
);

export const getCurrentItemId = createSelector(
    state => state.playbackState,
    playbackState => playbackState.currentItem && playbackState.currentItem.id
);

export const getCurrentAlbum = createSelector(
    state => state.playbackState,
    playbackState => playbackState.currentItem && playbackState.currentItem.album
);

export const getCurrentAlbumId = createSelector(
    state => state.playbackState,
    playbackState => playbackState.currentItem && playbackState.currentItem.album && playbackState.currentItem.album.id
);

export const isCurrentItemFirstInAlbum = createSelector(
    state => state.playbackState.playbackInfo,
    playbackInfo => playbackInfo && playbackInfo.item && playbackInfo.item.disc_number === 1 && playbackInfo.item.track_number === 1
)

export const getItemProgress = createSelector(
    state => state.playbackState.playbackInfo,
    playbackInfo => playbackInfo && playbackInfo.progress_ms
);

export const getShuffleState = createSelector(
    state => state.playbackState.playbackInfo,
    playbackInfo => playbackInfo && playbackInfo.shuffle_state
);

export const getRepeatState = createSelector(
    state => state.playbackState.playbackInfo,
    playbackInfo => playbackInfo && playbackInfo.repeat_state
);

export const getVolume = createSelector(
    state => state.playbackState.playbackInfo,
    playbackInfo => playbackInfo && playbackInfo.device && playbackInfo.device.volume_percent
);

export const supportsVolume = createSelector(
    state => state.playbackState.playbackInfo,
    playbackInfo => playbackInfo && playbackInfo.device && playbackInfo.device.supports_volume
)

const INITIAL_STATE = {
    playbackInfo: undefined,
    currentItem: undefined
}

export const playbackState = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_PLAYBACK_STATE:
            return {...state, playbackInfo: action.payload};
        case SET_CURRENT_ITEM:
            return {...state, currentItem: action.payload};
        default:
            return state;
    }
}